module.exports = __webpack_public_path__ + "static/media/veva-send-background.56141f11.jpg";